<template>
    <div :class="['cart-icon-container', 'grid-x align-middle', {'basket-cta': productsCount}, {hidden: hideButton}, {closed: storeClosed}]">
        <div class="align-middle cell show-for-large cart-button" dusk="open-cart" @click="openCart" v-if="productsCount">
            <span class="basket-icon" v-html="Icon.BASKET"></span>
            <span class="basket-text bold">{{ (maxProductsReached) ? 'Basket full' : 'View Basket' }}</span>
            <span class="bold">&nbsp;({{ productsCount }}) • ${{ total }}</span>
        </div>
        <transition name="quick-fade">
            <div class="cell hide-for-large mobile-basket-cta" dusk="open-cart-mobile" v-if="productsCount"  @click="openCart">
                <div class="align-middle grid-x align-justify grid-padding-x">
                    <div class="cell shrink">
                        <span class="basket-icon" v-html="Icon.BASKET"></span>
                        <span class="products-count display-xsmall-xbold">{{ productsCount }}</span>
                    </div>
                    <div class="text-center cell auto">
                        <p class="text-uppercase bold margin-0">{{ (maxProductsReached) ? 'Basket full' : 'View basket' }}</p>
                    </div>
                    <div class="text-right cell shrink">
                        <p class="margin-0">${{ total }}</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import CartModule from '@/stores/modules/cart';
import { getModule } from 'vuex-module-decorators';
import { Icon } from '@/front/icons';
import { registerGlobalEvent } from '@/utils/global-event';
import { registerScrollCallback, removeScrollCallback } from '@/utils/scroll-event-manager';
import { isStoreOpen } from '@/utils/store-schedule';
@Component
export default class CartIcon extends Vue
{
    cartModule!: CartModule;
    prevScrollTop: number = 0;
    hideButton: boolean = false;
    storeClosed: boolean = false;

    async created() {
        this.cartModule = getModule(CartModule, this.$store);
        this.storeClosed = !await isStoreOpen();
    }

    mounted() {
        registerScrollCallback('bottom-cart', this.onScroll);
        registerGlobalEvent('triggerNavigationDisplay', () => {
            window.setTimeout(() => this.hideButton = false, 100);
        });
    }

    openCart() {
        this.cartModule.setIsOpen(true);
    }

    onScroll(pageContentContainer: HTMLElement) {
        if (this.$route.name !== 'account') {
            if (pageContentContainer.scrollTop > this.prevScrollTop && pageContentContainer.scrollTop > 20) {
                this.hideButton = true;
            }
            if (pageContentContainer.scrollTop <= this.prevScrollTop) {
                this.hideButton = false;
            }
            this.prevScrollTop = pageContentContainer.scrollTop;
        }
    }

    destroyed() {
        removeScrollCallback('bottom-cart');
    }

    get maxProductsReached() {
        return this.cartModule.maxProductsReached;
    }

    get productsCount() {
        return this.cartModule.productsQuantity;
    }

    get total() {
        return this.cartModule.subtotal.toFixed(2);
    }

    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.basket-icon {
    height: 40px;
    position: relative;

    path {
        fill: var(--dark-gray);
    }
}

.basket-cta {
    .basket-icon path {
        fill: var(--basket-button-fg);
    }
}

.mobile-basket-cta {
    .basket-icon path {
        fill: var(--basket-button-fg-mobile);
    }
}

.cart-icon-container {
    cursor: pointer;
    position: relative;

    @include breakpoint(large up) {
        height: 100%;
    }

    &.basket-cta {
        transition: all 0.3s ease;
        color: var(--basket-button-fg);
        padding: 0 25px;

        @media screen and (max-width: 320px) {
            padding: 0 10px;
        }

        .cart-button {
            display: flex;
            background-color: var(--basket-button-bg);
            padding: var(--basket-button-padding);
            border-radius: var(--basket-button-radius);
        }

        @include breakpoint(medium down) {
            position: fixed;
            bottom: 60px;
            height: 70px;
            background-color: var(--basket-button-bg-mobile);
            color: var(--basket-button-fg-mobile);
            width: 100%;
            z-index: 9;
            padding-bottom: 15px;
            border-radius: var(--basket-button-mobile-radius) var(--basket-button-mobile-radius) 0 0;

            &.hidden {
                bottom: -120px;
            }

            .basket-icon {
                top: 6px;
            }
        }

        .products-count {
            background-color: var(--white);
            color: var(--primary);
            border-radius: 50%;
            padding: 5px 10px 5px 9px;
            position: relative;
            top: -2px;
            font-variant-numeric: tabular-nums;

            @include breakpoint(medium down) {
                padding: 3px 7px 3px 7px;
                top: -14px;
                left: -28px;
            }
        }
    }

    &.closed {
        display: none;
    }
}


</style>
